(function () {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function initAutoplaySlider(el) {
    if (el.dataset.autoplayInit) return;
    el.dataset.autoplayInit = 'true';
    if (prefersReducedMotion) return;

    var slider = el.querySelector('[id^="Slider-"]');
    if (!slider) return;

    var speedLevel = parseFloat(el.dataset.autoplaySpeed) || 4;
    var pxPerSecond = speedLevel * 20;

    var originalItems = Array.prototype.slice.call(slider.children);
    if (originalItems.length < 2) return;

    var controls = el.querySelector('.slider-buttons');
    if (controls) controls.style.display = 'none';

    var clonesAdded = false;
    var loopWidth = 0;
    var position = 0;
    var paused = false;
    var lastTime = null;

    function addClones() {
    if (clonesAdded) return;
    originalItems.forEach(function (item) {
    var clone = item.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.classList.add('autoplay-clone');
    clone.removeAttribute('id');
    var idEls = clone.querySelectorAll('[id]');
    idEls.forEach(function (node) { node.removeAttribute('id'); });
    var focusables = clone.querySelectorAll('a, button, input, [tabindex]');
    focusables.forEach(function (f) { f.setAttribute('tabindex', '-1'); });
    slider.appendChild(clone);
    });
    clonesAdded = true;
    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';
    loopWidth = slider.scrollWidth / 2;
    position = slider.scrollLeft;
    }

    function removeClones() {
    if (!clonesAdded) return;
    var clones = slider.querySelectorAll('.autoplay-clone');
    clones.forEach(function (c) { c.remove(); });
    clonesAdded = false;
    slider.style.scrollBehavior = '';
    slider.style.scrollSnapType = '';
    }

    function pause() { paused = true; }
    function resume() {
    if (clonesAdded) position = slider.scrollLeft;
    paused = false;
    }

    function frame(timestamp) {
    requestAnimationFrame(frame);
    if (!mobileQuery.matches || el.offsetParent === null) {
    lastTime = null;
    return;
    }
    if (!clonesAdded) addClones();
    if (lastTime === null) { lastTime = timestamp; return; }
    var delta = timestamp - lastTime;
    lastTime = timestamp;
    if (paused || !loopWidth) return;
    position += (pxPerSecond * delta) / 1000;
    if (position >= loopWidth) position -= loopWidth;
    slider.scrollLeft = position;
    }

    ['mouseenter', 'touchstart', 'pointerdown', 'focusin'].forEach(function (evt) {
    el.addEventListener(evt, pause, { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (evt) {
    el.addEventListener(evt, resume, { passive: true });
    });

    mobileQuery.addEventListener('change', function (event) {
    if (!event.matches) {
    pause();
    removeClones();
    lastTime = null;
    }
    });

    requestAnimationFrame(frame);
    }

    function init(root) {
    root = root || document;
    var sliders = root.querySelectorAll('slider-component[data-autoplay="true"]');
    sliders.forEach(function (el) {
    initAutoplaySlider(el);
    });
    }

    function boot(root) {
    if (window.customElements && customElements.get('slider-component')) {
    init(root);
    } else if (window.customElements) {
    customElements.whenDefined('slider-component').then(function () {
    init(root);
    });
    }
    }

    document.addEventListener('DOMContentLoaded', function () {
    boot();
    });
    document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    });
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
    boot();
    }
    })();